import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MapPinIcon, XIcon } from 'lucide-react';
import { PRODUCT_IMAGE, PRODUCT_NAME, recentBuyers } from '../data/salesContent';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      setVisible(true);
      hideTimer = setTimeout(() => {
        setVisible(false);
        setIndex(i => (i + 1) % recentBuyers.length);
      }, 5500);
    };
    const first = setTimeout(show, 7000);
    const interval = setInterval(show, 16000);
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-4 left-4 right-4 z-50 sm:right-auto" aria-live="polite" data-id="element-55" data-mp="1gydxm764p1mm">
      <AnimatePresence data-id="element-56" data-mp="163wdmu3ka43d">
        {visible && !dismissed && <motion.div key={index} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full items-center gap-3 rounded-2xl border-2 border-cyan-500 bg-zinc-950 p-3 pr-9 shadow-2xl shadow-cyan-500/20 sm:w-[22rem]" data-id="element-57" data-mp="117o1lpknur0f">
            <img src={PRODUCT_IMAGE} alt="" className="h-14 w-14 shrink-0 rounded-lg bg-white object-contain p-0.5" data-id="element-58" data-mp="x6c99caejroj" />
            <div className="min-w-0 text-sm leading-snug" data-id="element-59" data-mp="s4n0626qpo33">
              <p className="flex items-center gap-1.5 font-display text-xs font-extrabold uppercase tracking-wide text-cyan-400" data-id="element-60" data-mp="28jy8xrdw1bob">
                <span className="h-2 w-2 rounded-full bg-cyan-400" aria-hidden="true" data-id="element-61" data-mp="23klg8q0c5adt" />
                Compra reciente
              </p>
              <p className="mt-1 text-zinc-100" data-id="element-62" data-mp="2aqxjght3c6c3">
                <span className="font-semibold" data-id="element-63" data-mp="2fmmqt7bcqriy">{buyer.name}</span> compró el{' '}
                <span className="font-semibold text-cyan-300" data-id="element-64" data-mp="2kmhfr5bkh71d">{PRODUCT_NAME}</span>
              </p>
              <p className="mt-1 flex items-center gap-1 text-xs text-zinc-400" data-id="element-65" data-mp="2pm3tdfvb4pap">
                <MapPinIcon className="h-3.5 w-3.5 shrink-0 text-cyan-500" aria-hidden="true" data-id="element-66" data-mp="1rybvsksc7m2l" />
                {buyer.city}, {buyer.province} · Argentina
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute right-2 top-2 rounded p-1 text-zinc-500 transition-colors duration-150 hover:text-zinc-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400/50" data-id="element-67" data-mp="21w9iv4ygnctm">
              <XIcon className="h-4 w-4" data-id="element-68" data-mp="195rfs3xqlbg7" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}